import { render, staticRenderFns } from "./merchantRate.vue?vue&type=template&id=1df7eb2c&scoped=true&"
import script from "./merchantRate.vue?vue&type=script&lang=js&"
export * from "./merchantRate.vue?vue&type=script&lang=js&"
import style0 from "./merchantRate.vue?vue&type=style&index=0&id=1df7eb2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df7eb2c",
  null
  
)

export default component.exports